import React from 'react'
import { Upload } from 'antd'
import styles from './UploadControl.module.scss'
import { useComponentLocale } from '../hooks/useComponentLocale'
import fileUploadIcon from '../assets/upload-file.svg'
import folderUploadIcon from '../assets/upload-folder.svg'

function UploadDragger({ uploadRequest, uploadedFilesList, fileList, dragProps }) {
	const getLocale = useComponentLocale()

	const addMoreFilesLocale = getLocale({ component: 'uploadPage', section: 'add_more_files' })
	const clickOrDragLocale = getLocale({ component: 'uploadPage', section: 'drag_files' })
	const addMoreFolderLocale = getLocale({ component: 'uploadPage', section: 'add_folder_files' })
	const clickOrDragFolderLocale = getLocale({ component: 'uploadPage', section: 'drag_folder' })

	const isRowUploadDisplay = !!dragProps.fileList.length

	return (
		<>
			{!uploadRequest && !uploadedFilesList.length ? (
				<div className={styles.draggerWrapper + ' ' + (isRowUploadDisplay ? styles.draggerWrapperRow : '')}>
					<Upload.Dragger {...dragProps} className={styles.dragger}>
						<img src={fileUploadIcon} alt='file upload' width='40px' />
						<p className={styles.uploadTextHint}>
							{fileList.length ? addMoreFilesLocale : clickOrDragLocale}
						</p>
					</Upload.Dragger>
					<Upload.Dragger {...dragProps} className={styles.dragger} directory>
						<img src={folderUploadIcon} alt='folder upload' width='50px' />
						<p className={styles.uploadTextHint}>
							{fileList.length ? addMoreFolderLocale : clickOrDragFolderLocale}
						</p>
					</Upload.Dragger>
				</div>
			) : null}
		</>
	)
}

export default UploadDragger
